export const colSelect = {
    xs: { span: 24, offset: 0 }, //<576
    sm: { span: 24, offset: 0 }, //>576
    md: { span: 24, offset: 0 }, // >768
    lg: { span: 18, offset: 0 }, // > 992
    xl: { span: 13, offset: 0 }, // > 1200
    xxl: { span: 12, offset: 0 }, // > 1600
};
